import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";


function UploadFeeProof() {

  const [methods, setMethods] = useState([]);
  const [form, setForm] = useState({
    payment_method: "",
    payer_name: "",
    amount: "",
    payment_date: "",
    transaction_reference: "",
    receipt_image: null
  });

  const [message, setMessage] = useState("");
  const { t } = useTranslation();

  const token = localStorage.getItem("access");

  useEffect(() => {
    fetchMethods();
  }, []);

  const fetchMethods = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/fees/payment-methods/",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setMethods(res.data);

    } catch (err) {
      console.error(err);
    }

  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value
    });

  };

  const handleImage = (e) => {

    setForm({
      ...form,
      receipt_image: e.target.files[0]
    });

  };

  const submitProof = async (e) => {

    e.preventDefault();

    const data = new FormData();

    data.append("payment_method", form.payment_method);
    data.append("payer_name", form.payer_name);
    data.append("amount", form.amount);
    data.append("payment_date", form.payment_date);
    data.append("transaction_reference", form.transaction_reference);
    data.append("receipt_image", form.receipt_image);

    try {

      await axios.post(
        "https://api.eduskot.com/api/results/fees/upload-proof/",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMessage("Payment proof uploaded successfully.");

      setForm({
        payment_method: "",
        payer_name: "",
        amount: "",
        payment_date: "",
        transaction_reference: "",
        receipt_image: null
      });

    } catch (err) {

      console.error(err);
      setMessage("Failed to upload payment proof.");

    }

  };

  return (

    <div style={styles.page}>

      <h1 style={styles.title}>Upload Fee Payment Proof</h1>

      <form style={styles.form} onSubmit={submitProof}>

        {/* PAYMENT METHOD */}

        <label>{t("paymentMethod")}</label>

        <select
          name="payment_method"
          value={form.payment_method}
          onChange={handleChange}
          required
          style={styles.input}
        >

          <option value="">Select payment method</option>

          {methods.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}

        </select>


        {/* PAYER NAME */}

        {t("nameOfPersonWhoPaid")}

        <input
          type="text"
          name="payer_name"
          value={form.payer_name}
          onChange={handleChange}
          required
          style={styles.input}
        />


        {/* AMOUNT */}

        {t("amountPaid")}

        <input
          type="number"
          name="amount"
          value={form.amount}
          onChange={handleChange}
          required
          style={styles.input}
        />


        {/* PAYMENT DATE */}

        {t("dateOfPayment")}

        <input
          type="date"
          name="payment_date"
          value={form.payment_date}
          onChange={handleChange}
          max={new Date().toISOString().split("T")[0]}
          required
          style={styles.input}
        />


        {/* TRANSACTION REFERENCE */}

        {t("transactionReference")}

        <input
          type="text"
          name="transaction_reference"
          value={form.transaction_reference}
          onChange={handleChange}
          style={styles.input}
        />


        {/* IMAGE */}

        {t("uploadReceipt")}

        <input
          type="file"
          accept="image/*"
          onChange={handleImage}
          required
          style={styles.input}
        />


        <button type="submit" style={styles.button}>
          Submit Payment Proof
        </button>

        {message && <p style={styles.message}>{message}</p>}

      </form>

    </div>

  );
}

const styles = {

  page:{
    minHeight:"100vh",
    padding:"8px",
    background:"linear-gradient(120deg,#e0f2fe,#f0f9ff)",
    fontFamily:"Segoe UI"
  },

  title:{
    marginBottom:"30px"
  },

  form:{
    maxWidth:"500px",
    background:"white",
    padding:"30px",
    borderRadius:"12px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.1)"
  },

  input:{
    width:"100%",
    padding:"10px",
    marginBottom:"20px",
    borderRadius:"6px",
    border:"1px solid #cbd5e1"
  },

  button:{
    width:"100%",
    padding:"12px",
    background:"#2563eb",
    color:"white",
    border:"none",
    borderRadius:"8px",
    cursor:"pointer"
  },

  message:{
    marginTop:"15px",
    color:"#16a34a"
  }

};

export default UploadFeeProof;